import React from 'react'
import Navbar from './Navbar'
import LoginForm from './LoginForm'
import Footer from './Footer'
export default function LoginPage() {
    return (
        <>
            <Navbar />
            <LoginForm />
            <Footer />
        </>
    )
}
